import {
  CLEAR_NEW_CHAT_UNREAD_ROOM_IDS,
  FETCH_CHAT_LIST,
  CHATLIST_LOADING,
  LOGOUT,
  REMOVE_NEW_CHAT_UNREAD_ROOM_ID,
  SAVE_DECRYPTION_KEY,
  SET_NEW_CHAT_UNREAD_ROOM_IDS,
  TOGGLE_CHAT_BLOCK,
  UPSERT_NEW_CHAT_UNREAD_ROOM_ID,
  SET_MOBILE_UNREAD_CHAT_COUNT,
} from "../Actions/types";

const INITIAL_STATE = {
  isChatOpen: false,
  chatList: [],
  loading: false,
  decryptionKeys: {},
  mobileUnreadChatCount: 0,
  newChatUnreadRoomIds: [],
};

let chatReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CHAT_LIST:
      return { ...state, chatList: action.payload };

    case SET_MOBILE_UNREAD_CHAT_COUNT:
      return { ...state, mobileUnreadChatCount: action.payload };

    case SET_NEW_CHAT_UNREAD_ROOM_IDS: {
      const unreadRoomIds = [...new Set(action.payload)];
      return {
        ...state,
        newChatUnreadRoomIds: unreadRoomIds,
      };
    }

    case UPSERT_NEW_CHAT_UNREAD_ROOM_ID: {
      const roomId = action.payload;
      if (state.newChatUnreadRoomIds.includes(roomId)) {
        return state;
      }

      const unreadRoomIds = [...state.newChatUnreadRoomIds, roomId];
      return {
        ...state,
        newChatUnreadRoomIds: unreadRoomIds,
      };
    }

    case REMOVE_NEW_CHAT_UNREAD_ROOM_ID: {
      const unreadRoomIds = state.newChatUnreadRoomIds.filter(
        roomId => roomId !== action.payload
      );
      return {
        ...state,
        newChatUnreadRoomIds: unreadRoomIds,
      };
    }

    case CLEAR_NEW_CHAT_UNREAD_ROOM_IDS:
      return {
        ...state,
        newChatUnreadRoomIds: [],
      };

    case CHATLIST_LOADING:
      return { ...state, loading: action.payload };

    case SAVE_DECRYPTION_KEY:
      return {
        ...state,
        decryptionKeys: {
          ...state.decryptionKeys,
          [action.payload.chatChannel]: action.payload.key,
        },
      };

    case LOGOUT:
      return INITIAL_STATE;

    case TOGGLE_CHAT_BLOCK:
      return { ...state, isChatOpen: !state.isChatOpen };

    default:
      return state;
  }
};

export default chatReducer;
